'use strict';

angular.module('amexReconciliationApp')
  .filter('millisecondsToMinutes',
    function millisecondsToMinutes() {
      return function (millis) {
        var totalSeconds = millis / 1000;

        var minutes = Math.floor(totalSeconds / 60);
        var seconds = totalSeconds % 60;
        seconds = _.padStart(seconds.toString(), 2, '0');

        return minutes + ':' + seconds;
      };
    });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/filters/millisecondsToMinutesFilter.js
// module id = 557
// module chunks = 0